import React, { useState, useEffect } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";

import ApexChart from "react-apexcharts";
import CloseIcon from "@mui/icons-material/Close";



const MomentumPopup = ({ open, title, apiData, setOpen }) => {
  const handleClose = () => setOpen(false);

  

  const [chartState, setChartState] = useState({
    series: [
      {
        name: "Revenue",
        type: "column",
        data: [],
      },
      {
        name: "Budget",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false
        }
      },
      colors: ["#8BDBCD", "#F59D1E"],
      stroke: {
        width: [2, 0],
        curve: 'smooth',
        dashArray: 5,
        colors: [function({ value, dataPointIndex, w }) {
          const budgetData = w?.config?.series?.[1]?.data || []
          if(value < budgetData[dataPointIndex]) {
            return "#8BDBCD"
              
          }else {
              return ''
          }
        }]
      },
      plotOptions: {
        bar: {
          columnWidth: 47,
          borderRadius: 5,
          borderRadiusApplication: 'end',

        },
      },
      dataLabels: {
        enabled: false,
        // enabledOnSeries: [1],
        // // offsetX: 0,
        // formatter: function (val) {
        //   const value = Math.trunc(val).toString()
        //   return `  ${value}  `

        // },
        // textAnchor: 'middle',
        // style: {
        //   fontSize: "14px",
        //   fontWeight: "bold",
        //   colors: ["#F9E289"],
        //   width: '100px'
        // },
        // background: {
        //   enabled: true,
        //   foreColor: "#00000", 
        //   borderWidth: 1,
        //   borderColor: "#F59D1E",
        //   padding: [15]
        //   // width: 70, // Dynamically fit the bar width
        // },
      },
      fill: {
        colors: [function({ value, dataPointIndex, w }) {
          const budgetData = w?.config?.series?.[1]?.data || []
          if(value < budgetData[dataPointIndex]) {
              return '#edf9f7'
          }else {
              return "#8BDBCD"
          }
        }],
        pattern: {
          style: 'verticalLines',
          width: 6,
          height: 6,
          strokeWidth: 2,
        },
      },
      labels: [
      ],
    },
  });


  useEffect(() => {
    const annotations = []
    const revenue = []
    const budget = []
    const labels = []
    apiData.forEach((data, index) => {
      annotations.push({
        x: data.quarter, 
        y: 0, 
        marker: {
          size: 0,
          fillColor: "#fff",
          strokeColor: "#2698FF",
          radius: 0,
        },
        label: {
          borderColor: data.revenue < data.budget ? "#edf9f7" :"#9ee1d5",
          style: {
            color: "#000",
            background: data.revenue < data.budget ? "#edf9f7" :"#9ee1d5",
            fontSize: "14px",
            fontWeight: "bold",
          },
          
          text: `${Math.trunc(data.revenue)}`,
        },
      })
      const length = Math.trunc(data.budget).toString().length;
      const padding = { 1: 17, 2: 15, 3: 11 }[length] || 8;

      annotations.push({
        x: data.quarter, 
        y: data.budget, 
        // marker: {
        //   size: 0,
        //   fillColor: "#fff",
        //   strokeColor: "#2698FF",
        //   radius: 0,
        // },
        label: {
          offsetY: 15,
          borderColor: "#F59D1E",
          width: '60px',
          style: {
            color: "#000",
            background:"#F9E289",
            fontSize: "14px",
            fontWeight: "bold",
            padding: {
              left: padding,
              right: padding,
              top: 0,
              bottom: 2,
            }
          },
          
          text: `${Math.trunc(data.budget)}`,
        },
      })
      revenue.push(data.revenue)
      budget.push(data.budget)
      labels.push(data.quarter)
    });

    setChartState((chartState) => ({
      ...chartState,
      series: [
        {
          name: "Revenue",
          type: "column",
          data: revenue,
        },
        {
          name: "Budget",
          type: "line",
          data: budget,
        },
      ],
      options: {
        ...chartState.options,
        labels,
        annotations: {
        points: annotations
        }
      }
    }))

  }, [apiData])

  return (
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography
            variant="h6"
            sx={{ color: "#d32f2f", fontWeight: "bold" }}
          >
            {title} <span style={{ fontWeight: "400" }}>(Momentum)</span>
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ApexChart options={chartState.options} series={chartState.series} />
        </DialogContent>
      </Dialog>
  );
};

export default MomentumPopup;

